import {
  IItemSearchResponse,
  ItemFactory,
  ProductList,
  ProductListFilterItemRange,
  ProductListFilterItemRangeValue,
  ProductListFilterItemValueType,
} from "@connox/typescript-library";
import {getShopId} from "../../../lib/getShopId";

/**
 * Checks wether the min value set by the customer is below the range min value. This leverages the
 * default behaviour to unset a range filter, if a floor-rounded value is below the actual min value. <br>
 * This is necessary to show rebates "From XX percent". <br>
 * Returns the min value or false
 * @param instance
 * @param filters
 */
export const isPercentDiscountSetUnderMin = (
  instance: ProductList,
  filters: {[k: string]: ProductListFilterItemValueType},
): number | false => {
  const discountStateSetting = filters.percentageDiscount as ProductListFilterItemRangeValue | undefined;
  const discountInstanceSetting = instance.filter.filterItems.get("percentageDiscount") as
    | ProductListFilterItemRange
    | undefined;

  if (discountStateSetting && discountInstanceSetting && discountStateSetting.min <= discountInstanceSetting.value.min) {
    return discountStateSetting.min;
  } else {
    return false;
  }
};

/**
 * Pretty much a copy of the tslib `ProductList.send()` method, to apply some hijacked percentageDiscount
 * min values, that are below the very min value of the filter. See `isPercentDiscountSetUnderMin()`
 * @param instance
 * @param filters
 */
export const getItemsWithPercentDiscount = async (
  instance: ProductList,
  filters: {[k: string]: ProductListFilterItemValueType},
) => {
  let requestProductsPromise: Promise<IItemSearchResponse>;
  const percentDiscountMinValue = isPercentDiscountSetUnderMin(instance, filters);
  if (percentDiscountMinValue) {
    requestProductsPromise = ItemFactory.getItems(getShopId(), {
      ...instance.requestParams,
      percentageDiscount: `${percentDiscountMinValue}-`,
    }).then((result) => {
      instance.filter.applyFilterResult(result.availableFilters);
      instance.items = result.itemContent;
      instance.total = result.totalSearchHits;

      return result;
    });
  } else {
    requestProductsPromise = instance.send();
  }

  return await requestProductsPromise;
};
